interface propsDOO {
    originalObj: Object,
    mutableObj: Object
    returnAnswer?: 'boolean' | 'object'
}

type DataEntry = {
    before: any,
    after: any
}

export type DataObject = {
    [key: string]: DataEntry
}

export default function differenceOfObjects({ originalObj, mutableObj, returnAnswer }: propsDOO): DataObject {
    const differences: DataObject = {}
    
    // function compareTagArrays(tags1: Array<object>, tags2: Array<object>): object {
    //     const differences = {};
    //     tags1.forEach((tag1, index) => {
    //         const tag2 = tags2[index];
    //         for (const key in tag1) {
    //             if (tag1.hasOwnProperty(key) && tag1[key] !== tag2[key]) {
    //                 if (!differences[index]) {
    //                     differences[index] = {};
    //                 }
    //                 differences[index][key] = { tag1: tag1[key], tag2: tag2[key] };
    //             }
    //         }
    //     });
    //     return differences;
    // }
    
    for (const key in originalObj) {
        if (originalObj.hasOwnProperty(key)) {
            if (originalObj[key] !== mutableObj[key]) {
                // Обработка массива тегов
                // if (Array.isArray(task1[key]) && Array.isArray(task2[key])) {
                //     const tagDifferences = compareTagArrays(task1[key], task2[key]);
                //     if (Object.keys(tagDifferences).length > 0) {
                //         differences[key] = tagDifferences;
                //     }
                // } else {
                // }
                differences[key] = { after: originalObj[key], before: mutableObj[key] };
            }
        }
    }
    return differences
    // switch (returnAnswer) {
    //     case "boolean":
    //         return Object.keys(differences).length !== 0
    //     case 'object':
    //         return differences
    //     }
}